"use strict";

angular.module("customer")
.component("inviteToRegisterBanner", {
    templateUrl: require("./invite-to-register-banner.component.html"),
    controller: InviteToRegisterBannerController
});

function InviteToRegisterBannerController($scope, $state, UserService) {
    $scope.displayAlertInfo = false;
    $scope.customerId = null;

    function updateScope(user) {
        if (
            $state.current.name !== "customer-listing"
            && $state.current.name !== "partnership-listing"
            && user
            && !user.have_to_agree_tos
            && user.customer
        ) {
            $scope.displayAlertInfo = user.allows_invite_to_register;
            $scope.customerId = user.customer.id;
        }
        else {
            resetScope();
        }
    }

    function resetScope() {
        $scope.displayAlertInfo = false;
        $scope.customerId = null;
    }

    UserService.isUserFetched().then(function onSuccess(user) {
        updateScope(user);
    });

    $scope.$on("UserUpdated", function onSuccess(event, user) {
        updateScope(user);
    });

    $scope.$on('$stateChangeSuccess', function() {
        UserService.isUserFetched().then(function onSuccess(user) {
            updateScope(user);
        });
    });

    $scope.$on("UserLoggedOut", function() {
        resetScope();
    });
}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/invite-to-register/banner/invite-to-register-banner.component.js
// module id = 861
// module chunks = 0